import styled from '@emotion/styled';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { PresentedMyme } from '@myme/api';
import { mymeDetailsPageRoute } from 'src/routes/route-list';
import { ImageCell, LinkCellWrapper, TooltipCell } from 'src/components/organisms/data-grid';

interface Props {
  params: GridRenderCellParams<PresentedMyme>;
}

const StyledTableCell = styled.div`
  width: 22.5rem;
  display: grid;
  align-items: center;
  grid-template-columns: 2rem min-content;
  grid-column-gap: 0.5rem;
`;

export const PreviewMymeTableCell = ({ params }: Props) => {
  if (!params.value) {
    return null;
  }

  const { previewImageFilePath, name, id } = params.value;

  return (
    <LinkCellWrapper to={mymeDetailsPageRoute(id)}>
      <StyledTableCell>
        <ImageCell src={previewImageFilePath} defaultPhoto='Logo.png' />
        <TooltipCell value={name} width={320} />
      </StyledTableCell>
    </LinkCellWrapper>
  );
};
